import React, {Component} from 'react';
import Swal from 'sweetalert2';
import moment from 'moment-timezone';
import Parse from '../../../Parse';

class DeleteActivities extends Component {

    formatActivityStatus = (status) => {
        switch(status) {
            case "pending":
                return (
                    <span className="label label-warning">Pending</span>
                );
            case "pending_backup":
                return (
                    <span className="label label-warning">Restoring</span>
                );
            case "completed_backup":
                return (
                    <span className="label label-success">Completed Restore</span>
                );
            case "completed":
                return (
                    <span className="label label-success">Completed</span>
                );
            case "cancel_backup":
                return (
                    <span className="label label-danger">Canceled Restore</span>
                );
            case "cancel":
                return (
                    <span className="label label-success">Canceled</span>
                );
            default:
                return (
                    <span className="label label-danger">No Status</span>
                );
        }
    }

    viewProfile = (report) => {
        const detail = report.get('detail');
        let html = ``;
        const tables = Object.keys(detail);
        for(let i = 0; i < tables.length; i++) {
            const table = tables[i];
            if(detail[table] == undefined || !detail[table]) {
                continue;
            }
            html += `
                <div style="text-align: left;">
                    <h5>Request Class: ${table}</h5>
                    <p>Total Removed: ${detail[table].noDeleted || 0}</p>
                    <p>Total Runned: ${detail[table].noRun || 0}</p>
                    <p>Total Restored: ${detail[table].noRestored || 0}</p>
                    <p>Total Inserted: ${detail[table].noInserted || 0}</p>
                    <p>------------------------------------------------</p>
                    <p>Finished: ${detail[table].finished ? `Completed` : `Not Complete`}</p>
                    <p>Restored: ${detail[table].restored ? `Completed` : `Not Complete`}</p>
                    <br>
                </div>
            `
        }
        Swal.fire({
            title: "The Profiler",
            html: html
        })
    }

    render() {
        const activities = [...this.props.activities];
        return (
            <div className="box box-default">
                <div className="box-header with-border">
                    <h3 className="box-title">Activity Removed</h3>
                    <div className="box-tools">
                        <button className="btn btn-default btn-sm" onClick={this.props.refresh}>
                            <i className="fa fa-refresh"></i>
                            Refresh
                        </button>
                    </div>
                </div>
                <div className="box-body">
                    <div className="col-xs-12 col-md-12 col-lg-12 table-responsive no-padding">
                        <table className="table table-hover reportTable">
                            <tbody>
                                <tr>
                                    <th></th>
                                    <th>Date</th>
                                    <th>Request</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                                {
                                    activities.map((value, key) => {
                                        const status = value.get('status');
                                        const request = value.get('request');
                                        const owner = request.owner !== undefined && request.owner ? request.owner : null;
                                        const controller = request.controller !== undefined && request.controller ? request.controller : null;
                                        return (
                                            <tr key={key}>
                                                <td>
                                                    {
                                                        <a onClick={() => this.viewProfile(value)}>Profiler</a> 
                                                    }
                                                </td>
                                                <td>
                                                    <p>{owner ? `Owner: ${owner}` : null}</p>
                                                    <p>{controller ? `Controller: ${controller}` : null}</p>
                                                </td>
                                                <td>{moment(value.createdAt).format("LLL")}</td>
                                                <td>
                                                    {this.formatActivityStatus(status)}
                                                </td>
                                                <td>
                                                    {
                                                        <a onClick={() => this.props.restore(value.id)}>Restore</a> 
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>    
                    </div>
                </div>
            </div>
        );
    }
}

export default DeleteActivities;